import { render } from "./Edit.vue?vue&type=template&id=4c1cef7a"
import script from "./Edit.vue?vue&type=script&lang=js"
export * from "./Edit.vue?vue&type=script&lang=js"

import "./Edit.vue?vue&type=style&index=0&id=4c1cef7a&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/VariantGroups/Edit.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "4c1cef7a"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('4c1cef7a', __exports__)) {
    api.reload('4c1cef7a', __exports__)
  }
  
  module.hot.accept("./Edit.vue?vue&type=template&id=4c1cef7a", () => {
    api.rerender('4c1cef7a', render)
  })

}


export default __exports__